<template>
    <div>
        <div class="pagination" v-if="show">
            <button class="page" type="button" @click="go(1)" :disabled="current === 1">首页</button>
            <button class="page" type="button" @click="go(n)" :class="{'current':current === n}" v-for="n of pages" :key="n">{{n}}</button>
            <button class="page" type="button" @click="go(totalPages)" :disabled="current === totalPages">尾页</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        current: {
            type: Number,
            default: 1,
            validator: function (val) {
                return val > 0
            }
        },
        length: {
            type: Number,
            default: 20,
            validator: function (val) {
                return val > 0
            }
        },
        total: {
            type: Number,
            default: 0,
            validator: function (val) {
                return val >= 0
            }
        },
        step: { // 步长，显示的分页数量
            type: Number,
            default: 5,
            validator: function (val) {
                return val >= 0
            }
        },
        autoHide: { // 自动隐藏
            type: Boolean,
            default: true
        },
        pageClick: Function
    },
    computed: {
        totalPages: function () {
            let that = this
            return Math.ceil(that.total / that.length)
        },
        max: function () {
            let that = this
            if (that.totalPages === 0) {
                return 1
            }
            if (that.totalPages <= that.step) { // 
                return that.totalPages
            } else {
                let t = Math.ceil((that.step - 1) / 2.0)
                let max = that.current + t
                if (max >= that.totalPages) {
                    return that.totalPages
                } else {
                    if ((max - that.step) >= 0) {
                        return max
                    } else {
                        return that.current + that.step - 1
                    }
                }
            }
        },
        min: function () {
            let that = this
            let sub = that.max - that.step + 1
            if (sub > 0) {
                return sub;
            } else {
                return 1;
            }
        },
        pages: function () {
            let that = this;
            let tmp = []
            for (let x = that.min; x <= that.max; x++) {
                tmp.push(x)
            }
            return tmp
        },
        show: function () {
            let that = this
            if (!that.autoHide) {
                return true
            }
            return that.totalPages > 1
        }
    },
    methods: {
        go: function (page) {
            let that = this
            if (that.current !== page && that.pageClick) {
                that.pageClick(page)
            }
        }
    }

}
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// pagination.vue?1fdf354f